/** Job hiring status helpers (mirrors server jobHiring.js). */

export function isJobActivelyHiring(job) {
  return job && ['open', 'in-progress', 'on-hold'].includes(job.status);
}

export function getJobStatusDistribution(jobs = []) {
  return {
    open: jobs.filter(j => j.status === 'open').length,
    'in-progress': jobs.filter(j => j.status === 'in-progress').length,
    'on-hold': jobs.filter(j => j.status === 'on-hold').length,
    closed: jobs.filter(j => j.status === 'closed').length,
    inactive: jobs.filter(j => j.status === 'inactive').length
  };
}

export function formatJobStatusLabel(status) {
  const labels = {
    open: 'Open',
    'in-progress': 'In progress',
    'on-hold': 'On hold',
    closed: 'Closed',
    inactive: 'Inactive'
  };
  return labels[status] || status;
}
